import {
  InsuranceCardDetails,
  Vaccine,
  VerifyAppointmentSchedulerTokenResponse
} from '../../services/service-mappers/AppointmentSchedulingMapper';
import {
  APPOINTMENT_LOGIN,
  APPOINTMENT_LOGOUT,
  PATIENT_APPOINTMENT_TOKEN,
  SET_APPOINTMENT_PORTAL_COMMON,
  SET_APPOINTMENT_PORTAL_INSURANCE_DETAILS,
  SET_AVAILABLE_VACCINE_LIST
} from '../actions/Index';

interface AppointmentSchedulerState {
  isLogin: boolean;
  patientAppointmentToken: string;
  insuranceCardDetails: InsuranceCardDetails | null;
  details: VerifyAppointmentSchedulerTokenResponse | null;
  vaccineList: Vaccine[];
}

const initState: AppointmentSchedulerState = {
  isLogin: false,
  patientAppointmentToken: '',
  insuranceCardDetails: null,
  details: null,
  vaccineList: []
};

export default function (
  state = initState,
  action: any
): AppointmentSchedulerState {
  const {type, payload} = action;
  switch (type) {
    case APPOINTMENT_LOGIN:
      return {
        ...state,
        isLogin: payload.isLogin
      };
    case PATIENT_APPOINTMENT_TOKEN:
      return {
        ...state,
        patientAppointmentToken: payload.patientAppointmentToken
      };
    case APPOINTMENT_LOGOUT:
      return {
        ...initState
      };
    case SET_APPOINTMENT_PORTAL_INSURANCE_DETAILS:
      return {
        ...state,
        insuranceCardDetails: payload
      };
    case SET_APPOINTMENT_PORTAL_COMMON:
      return {
        ...state,
        details: payload
      };
    case SET_AVAILABLE_VACCINE_LIST:
      return {
        ...state,
        vaccineList: payload.vaccineList
      };
    default:
      return state;
  }
}
